import { render, staticRenderFns } from "./tableDiv.vue?vue&type=template&id=319c832d&scoped=true&"
import script from "./tableDiv.vue?vue&type=script&lang=js&"
export * from "./tableDiv.vue?vue&type=script&lang=js&"
import style0 from "./tableDiv.vue?vue&type=style&index=0&id=319c832d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319c832d",
  null
  
)

export default component.exports